export { DialogSureBack } from './dialog-sure-back';

export type { DialogSureBackProps } from './dialog-sure-back';
